import React, { useState } from 'react';

const FIELDS = [
    { key: 'friendly_name', label: 'Friendly name', type: 'text' },
    { key: 'description', label: 'Description', type: 'text' },
    { key: 'latitude', label: 'Latitude', type: 'number' },
    { key: 'longitude', label: 'Longitude', type: 'number' },
];
const EMPTY_FORM = { friendly_name: '', description: '', latitude: '', longitude: '' };

// Device picker plus its metadata. Editing is for admins only (`canEdit`);
// the backend enforces that too. With a single device the picker is hidden.
const DeviceInfoCard = ({ devices, selectedDeviceId, onSelect, deviceInfo, onSave, canEdit = false }) => {
    const [form, setForm] = useState(EMPTY_FORM);
    const [saving, setSaving] = useState(false);
    const changes = Object.fromEntries(Object.entries(form).filter(([, v]) => v !== ''));
    const hasChanges = Object.keys(changes).length > 0;

    const handleSave = async () => {
        setSaving(true);
        if (await onSave(changes)) setForm(EMPTY_FORM);
        setSaving(false);
    };

    return (
        <div className="space-y-4">
            {devices.length > 1 && (
                <div className="w-full max-w-md mx-auto">
                    <select
                        aria-label="Device"
                        onChange={(e) => onSelect(e.target.value || null)}
                        value={selectedDeviceId || ''}
                        className="w-full px-4 py-2 bg-white border border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:border-rebel-green transition-colors"
                    >
                        <option value="">Select a device</option>
                        {devices.map(device => (
                            <option key={device.device_id} value={device.device_id}>
                                {device.metadata?.friendly_name || device.device_id}
                            </option>
                        ))}
                    </select>
                </div>
            )}

            {selectedDeviceId && (
                <div className="w-full max-w-4xl mx-auto">
                    <div className="bg-white rounded-lg shadow-md overflow-hidden">
                        <table className="w-full">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Value</th>
                                    {canEdit && <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Update</th>}
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {FIELDS.map(({ key, label, type }) => (
                                    <tr key={key} className="hover:bg-gray-50">
                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{label}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{deviceInfo[key]}</td>
                                        {canEdit && (
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <input
                                                    type={type}
                                                    step={type === 'number' ? 'any' : undefined}
                                                    aria-label={`New ${label.toLowerCase()}`}
                                                    value={form[key]}
                                                    onChange={(e) => setForm({ ...form, [key]: e.target.value })}
                                                    placeholder={`Update ${label.toLowerCase()}`}
                                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-rebel-green transition-colors"
                                                />
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {canEdit && (
                        <div className="flex justify-center mt-6">
                            <button
                                onClick={handleSave}
                                disabled={!hasChanges || saving}
                                className="bg-rebel-green hover:bg-green-600 disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-semibold py-3 px-8 rounded-lg transition-all duration-300"
                            >
                                {saving ? 'Saving...' : 'Update device information'}
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default DeviceInfoCard;
